import { ActivityTrackerFactory, Trackers } from '@/services/activityTracker/factories/activity-tracker-factory';
import { CLICK } from '@/services/activityTracker/events/click';
import { loggedIn, user } from '@/ui/auth/auth';
import { isPdf, isProd } from '@/ui/helpers/systemHelper';

export enum EventTypes {
  click = 'click',
  filter = 'filter',
  customizeHeader = 'customize-header',
  conductInspection = 'conduct-inspection',
  imageUpload = 'image-upload',
  inviteUsers = 'invite-users',
  inviteUser = 'invite-user',
  urlVisit = 'url-visit',
  dragAndDrop = 'drag-and-drop',
  inputChange = 'input-change',
  roleAdd = 'role-add',
  registered = 'registered',
  templateFileAttached = 'template-file-attached',
  segmentationViewed = 'segmentation-viewed',
  segmentationFinished = 'segmentation-finished',
}

export enum FilterTypes {
  search = 'search',
  category = 'category',
  status = 'status',
  entityItem = 'entity-item',
  assignee = 'assignee'
}

export const CLICK_EVENTS = CLICK;

export const EVENTS = {
  HEADER_CUSTOMIZED: {
    page: 'Checklist builder',
    target: 'header-customized',
    label: 'Customize header',
  },
  SUBMIT_INSPECTION: {
    page: 'Inspection create',
    target: 'inspection-submit',
    label: 'Submit inspection',
  },
  LOGO_UPLOAD: {
    page: 'Checklist builder',
    label: 'Upload logo',
    target: 'upload-logo',
  },
  ATTACH_FILE: {
    page: 'Checklist builder',
    label: 'Attach file',
    target: 'attach-file',
  },
  INVITE_USERS: {
    page: 'Checklist builder',
    label: 'Invite users',
    target: 'user-invite',
  },
  INVITE_USER: {
    label: 'Invite users',
    target: 'user-invite',
  },
  SET_WEIGHT: {
    page: 'Checklist builder',
    label: 'Section',
    target: 'set-weight',
  },
  DRAG_AND_DROP: {
    page: 'Checklist builder',
    target: 'item-reorder',
  },
  PERMISSION_SELECTED: {
    page: 'Role create/edit',
    target: 'permission-selected',
    label: 'Permission selected',
  },
  SEGMENTATION_VIEWED: {
    page: 'User segmentation',
    target: 'segmentation-viewed',
  },
  SEGMENTATION_FINISHED: {
    page: 'User segmentation',
    target: 'segmentation-finished',
  },
};

const trackingService = isProd && !isPdf ? process.env.VUE_APP_TRACKING_SERVICE : '';
const activityTracker = (new ActivityTrackerFactory).make(trackingService as Trackers);

export type ClickProperties = { page: string; target: string; label?: string; [key: string]: unknown };
type FilterProperties = { page: string; [key: string]: unknown };
type EventProperties = { page: string; [key: string]: unknown };
export type Options = Record<string, unknown>;

export const unsetUserId = () => activityTracker.unsetUser();

export const setUserId = (id: string) => activityTracker.setUser(id);

export const trackEvent = (event: string, properties: EventProperties, options: Options = {}) => {
  const _properties = { ...properties, ...options };

  if (loggedIn.value) {
    _properties.organization_id = user.value.organization.id;
  }

  activityTracker.trackEvent(event, _properties);
};

export const trackClick = (properties: ClickProperties, options: Options = {}) =>
  trackEvent(EventTypes.click, properties, options);

export const trackFilter = (filter: string, properties: FilterProperties, options: Options = {}) =>
  trackEvent(EventTypes.filter, { type: filter, ...properties }, options);
